<template>
  <div id="app" v-if="show">
    <transition :name="SkipSwitchName">
      <router-view :key="$route.fullPath"></router-view>
    </transition>
    <div v-if="$store.state.isSim" class="sim-tag">{{$t('trade').simulatedTrading }}</div>
  </div>
</template>

<script>
import { EventBus } from '@/utils/event-bus'
import systemApi from '@/api/system'
import { mapGetters } from 'vuex'

export default {
  name: 'App',

  data() {
    return {
      SkipSwitchName: '',
      show: false
    }
  },
  created() {
    this.getbasic()
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {
    localStorage.setItem('theme', 'dark')
    document.documentElement.className = localStorage.getItem('theme')
    EventBus.$on('theme', (val) => {
      document.documentElement.className = val
    })
  },
  methods: {
    async getbasic() {
      let localLang = ''
      localLang = localStorage.getItem('language') || 'en' // 默认语言
      this.$i18n.locale = localLang
      this.$store.commit('SET_LANG', localLang, false)
      localStorage.setItem('language', localLang)
      //平台名称 logo
      const res = await systemApi.getConfig()
      localStorage.setItem('platformName', res.systemSetting.platformName) // 平台名称
      localStorage.setItem('platformLogo', window.baseURL + res.systemSetting.platformLogo)// 平台logo
      document.title = res.systemSetting.platformName
      document.querySelector("link[rel~='icon']").href = window.baseURL + res.systemSetting.platformLogo
      this.show = true
    }
  }
}
</script>
<style>
/* 全局 CSS 变量定义 - 亮色主题 */
:root {
  --primary_color: #00cdcf;
  /* 主色 */
  --background_color: #ffffff;
  /* 背景颜色 */
  --info_color: #f4f5f7;
  /* 次背景颜色 */
  --text_color: #1b1b1b;
  /* 文本颜色 */
  --ntext_color: #7e8797;
  /* 次文本颜色 */
  --line_color: #eeeeee;
  --color-linearStart: rgba(49, 140, 255, 0.1);
  --select_info_color: #eeeeee;
  --tbg_color: #f3f3f3;
  --tinfo_color: #ffffff;
}

/* 暗色主题定义 */
.dark {
  --primary_color: #00cdcf;
  /* 主色 */
  --background_color: #000000;
  /* 背景颜色 */
  --info_color: #1b1b1b;
  /* 次背景颜色 131722 */
  --text_color: #ffffff;
  /* 文本颜色 */
  --ntext_color: #a3a3a5;
  /* 次文本颜色 */
  --line_color: #333333;
  --color-linearStart: rgba(46, 74, 157, 0.5);
  --select_info_color: #2b2a2a;
  --tbg_color: #000000;
  --tinfo_color: #0f0f0f;
}
.sim-tag {
  position: fixed;
  right: 0;
  top: 40%;
  z-index: 9999;
  opacity: 0.5;
  background: var(--text_color);
  color: var(--background_color);
  padding: 8px 6px;
  font-size: 14px;
  font-weight: bold;
  writing-mode: vertical-rl;
  letter-spacing: 2px;

  border-radius: 6px 0 0 6px;
}
</style>
